export const Options = {
    Salutation: [
        { text: "Frau", value: "w" },
        { text: "Herr", value: "m" },
        { text: "Guten Tag", value: "d" },
    ]
}
